module.exports = "/v8.52.0/08cac9f/bundles/manifest.json";